import React from 'react'
import SelectIndustriesModal from "./SelectIndustriesModal";
import ProfileItemForm from "./ProfileItemForm";

export default class IndustryForm extends ProfileItemForm {

    static ItemType = 'Industry'

    static FormClass = 'talent-role-form talent-interest-form add-talent-form '

    static TypeConfig = {
        icon: 'fas fa-chart-pie',
        color: TB.config('color.secondary')
    }

    getModelFromProps() {
        let {self_score, ...industries_worked} = {...this.props.model};

        if(!TB.keys(TB.tryObject(industries_worked)).length) return {};

        return {industries_worked, self_score}
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        if (!model.industries_worked?.id) {
            delete model.self_score;
        }else if(model.industries_worked?.id && this.getModelFromProps().industries_worked?.id !== model.industries_worked.id) {
            let industryIds = TB.map((this.props.industries_worked || []),'id');

            if(this.getModelFromProps().industries_worked?.id) {
                industryIds = TB.filter(industryIds, id => id !== this.getModelFromProps().industries_worked?.id);
            }

            if (industryIds.length && industryIds.includes(model.industries_worked.id)) {
                this.formRef.current.forceValidate();
            }
        }


        return this.setState({model})
    }
    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    onSubmit() {

        let {self_score, industries_worked} = {
            ...this.getModelFromProps(),
            ...this.state.model
        };
        return super.onSubmit({
            self_score,
            ...industries_worked
        });
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        let hasIndustrySelected = TB.isDefined(this.state.model.industries_worked?.id);

        return [
            {
                style: styles.fieldSection,
                fields: {
                    industries_worked: {
                        type: 'search',
                        searchType: 'client_industries',
                        placeholder: TB.trans('talent.industry_form.industry_placeholder'),
                        valueLabelDisplay: 'name',
                        disabled: this.props.disabled,
                        label: TB.trans('talent.industry_form.industry_label'),
                        required: true,
                        columns: 12,
                        style: styles.field,
                        validations: {
                            industryNotSelected: ({industry}, value) => {
                                if (!TB.isDefined(value?.id)) {
                                    return TB.trans('talent.industry_form.validations.industry_not_selected_msg')
                                }

                                return TB.isDefined(value?.id) ? true : TB.trans('validation.required', {
                                    'attribute': "industry",
                                })
                            },
                            industryAlreadySelected: ({industry}, value) => {

                                let industryIds = TB.map((this.props.industries_worked || []),'id');

                                if(this.getModelFromProps().industries_worked?.id) {
                                    industryIds = TB.filter(industryIds, id => id !==this.getModelFromProps().industries_worked?.id);
                                }

                                if (TB.isDefined(value?.id) && industryIds.length && industryIds.includes(value.id)){
                                    return "Industry already selected";
                                }

                                return true;
                            }
                        },
                        validationErrors: {
                            isDefaultRequiredValue: TB.trans('validation.required', {
                                'attribute': "industry",
                            })
                        },
                        appendAfter: !hasIndustrySelected && (
                            <p className="btn-form-modal" onClick={() => {
                                this.showModal()
                            }}>
                                {TB.trans('talent.industry_form.modal_link')}
                            </p>
                        )
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    self_score: {
                        type: 'experience',
                        label: TB.trans('talent.industry_form.self_score_label'),
                        required: true,
                        disabled: this.props.disabled || !hasIndustrySelected,
                        options: laravel.importance_levels,
                        style: styles.field,
                        hideVisibility: !hasIndustrySelected,
                        columns: 12,
                    },
                }
            }
        ];
    };


    showModal() {
        return TB.event("Modal@show", {
            title: TB.trans('talent.industry_form.modal_title'),
            content: (
                <SelectIndustriesModal
                    selectIndustry={async (industries_worked) => {
                        if (!this.formRef || !this.formRef.current) {
                            return;
                        }
                        await this.formRef.current.updateInputsWithValue({
                            industries_worked
                        })
                        await TB.event("Modal@hide", true);
                    }}/>
            )
        })
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};